import React, { useMemo, useState } from 'react';
import AccountsCard from '../AccountsCard';
import { chooseSelectOptions } from '../../constants';
import FilterBoxCommon from '@/pages/opinion/components/FilterBoxCommon';
import './index.scss';  
import { JumpType } from '@home/utils/utils';

export default function CommentsCard({
  type,
  navigators,
  loading,
  keepParams,
  accountOrderBy,
  setAccountOrderBy,
  setNoDataMap,
  noDataMap,
  wholeGameInfo,
  gameInfo,
  jumpType,
}: {
  loading: boolean;
  type: string;
  navigators: Array<any>;
  keepParams: any;
  accountOrderBy: string;
  setAccountOrderBy: (value: string) => void;
  setNoDataMap: (key: string, value: boolean) => void;
  noDataMap: { [key: string]: boolean };
  wholeGameInfo?: any;
  gameInfo?: any;
  jumpType?: JumpType;
}) {
  const [languageType, setLanguageType] = useState('origin');
  const hideFilter = useMemo(() => {
    return !Object.values(noDataMap).every((item) => item);
  }, [noDataMap]);
  const filterLeftList = useMemo(() => {
    const filters: Array<any> = [{ key: 'language' }];
    if (type === 'account') {
      filters.push({
        key: 'sortBy',
        defaultValue: accountOrderBy,
        defaultParams: {
          options: chooseSelectOptions,
          style: { width: 260 },
        },
      });
    }

    return filters;
  }, []);
  return (
    <>
      {hideFilter && (
        <FilterBoxCommon
          left={filterLeftList}
          right={[]}
          className="dbo-accounts-justify"
          onChange={function (value: any, key?: any): void {
            if (key === 'language') {
              setLanguageType(value[key]);
            } else if (key === 'sortBy') {
              setAccountOrderBy(value[key]);
            }
          }}
        ></FilterBoxCommon>
      )}
      <div className="comments-card-wrapper">
        {/* 信息内容部分 */}
        {navigators.map((item) => {
          if (item.total === 0) {
            return <div key={item.name} id={item.name}></div>;
          }
          return (
            <section
              key={item.name}
              className="card-item-box-detail"
              style={{
                visibility: noDataMap[item.name] ? 'hidden' : 'visible',
                height: noDataMap[item.name] ? 0 : 'auto',
              }}
              id={item.name}
            >
              <AccountsCard
                key={item.symbol}
                navigator={item}
                type={type}
                setNoDataMap={(value: boolean) => {
                  setNoDataMap(item.name, value);
                }}
                languageType={languageType}
                keepParams={keepParams}
                channel={item.channel}
                wholeGameInfo={wholeGameInfo}
                gameInfo={gameInfo}
                jumpType={jumpType}
              ></AccountsCard>
            </section>
          );
        })}
      </div>
    </>
  );
}
